import type { ScriptStep } from '@features/scripts/types/steps';

/**
 * Canonical Master Setup a new robot is seeded with. Value-identical to the
 * backend fail-closed default (RobotMasterSteps.DefaultSetup, C#) — the two
 * cannot share code across languages, so both are kept in sync with the
 * canonical sequence in EPIC VOLTBOT-458. The 5000ms warm-up wait is locked.
 */
export const DEFAULT_MASTER_SETUP: ScriptStep[] = [
  { action: 'POWER_ON_STEPPERS' },
  { durationMs: 5000, label: 'Wait for steppers to power on' },
  { action: 'TURN_ON_ALL_STEPPERS' },
  { action: 'HOME_ALL_STEPPERS' }
];

/**
 * Canonical Master Teardown a new robot is seeded with — the guaranteed
 * power-down. Value-identical to the backend fail-closed default
 * (RobotMasterSteps.DefaultTeardown, C#). Never empty.
 */
export const DEFAULT_MASTER_TEARDOWN: ScriptStep[] = [
  { action: 'TURN_OFF_ALL_STEPPERS' },
  { action: 'POWER_OFF_STEPPERS' }
];
